export default __webpack_public_path__ + "static/media/General_de_divisao_Elias_Rodrigues_Martins_Filho.32fb5d6b.png";